// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"kr-z","imageAndVideoCount":"lr-z","imageAndVideoContainer":"mr-z","viewAllReviews":"nr-z"};